module.exports = __webpack_public_path__ + "img/img-6.0e44bfc1.png";